<template>
   <div v-if="this.$store.state.ResetrouterNavWidth!=0" class="left-div"  :style='{width:(this.$store.state.ResetrouterNavWidth)+"px",height:(this.$store.state.windowHeight-130)+"px"}'>
      <div v-for="(item,index) in list" :key="index">
         <div  class="common-space-between common-items-center btn " :class='[index == indexNo? "active":""]'  @click="selectBtn(item,index)">
               <div class="name">{{item.name}}</div>
         </div>
      </div> 
   </div>
</template>
<script>
  import {url,operate} from '@/utils/config'
  import {postFun,putFun} from '@/utils/httpFun'
  export default{
    data:()=>({
        title:"修改系统名称",
        showWindow:false, 
        indexNo:0,
        id:0,
        showBtn:false,
        formDate: {
            name: '',
            simpleName: "",
            orderNo:1,
            enabled:false,   
        },
        list:[]
    }),
    created(){
        this.getList()
    },
    methods:{
       //获取数据 
        async getList(){
          await postFun(operate.MODULElIST,{},res=>{
             let list = res.data
             this.list = res.data
             this.$parent.getList(list[0])
          })
        },
      
        //选择
        selectBtn(ev,indexNo){ 
           this.indexNo = indexNo
           this.$parent.getList(ev)
        }
    }
  }
</script>
<style lang="scss" scoped>
    .left-div{
       border-radius: 4px;
       padding: 15px;
       box-sizing: border-box;
       overflow-y: auto;
       .btn{
          background:rgba(180,180,180,0.1);
          border-radius: 6px;
          height: 42px;
          margin-right: 0;
          cursor: pointer;
            margin-bottom: 10px;
            padding:0 10px;
            box-sizing: border-box;
            line-height: 42px;
          .name{
             width:100px;
             color:#4D5C72;
             overflow:hidden;
             font-size: 14px;
             white-space: nowrap;
             text-overflow: ellipsis;
             -o-text-overflow:ellipsis;
          } 
       }
       .btn.active{
          background:rgba(24,115,255,0.4);
          border-radius: 6px;
       }
    }
   
</style>